import { useEffect, useState } from 'react';
import { URLSearchParamsInit, useSearchParams } from 'react-router-dom';
import InputElement from './InputElement';
import YesOrNoElement from './YesOrNo';
import Dropdown from './Dropdown';
import LocalStorage from 'Helpers/MFXLocalStorage';
import URLS from '../Utils/URLs.API';
import loadJsonData from '../Utils/loadJsonData';
import SessionStorage from '../../../Helpers/MFXSessionStorage';

export default function Filter(props: any) {
    const [filterValues, setFilterValues] = useState(null as any);
    const [profCritFilterValues, setProfCritFilterValues] = useState([] as any);
    const [specialFilter, setSpecialFilter] = useState([
        /*{ Key: 'OnlyOwnTasks', Value: props.specialFilter.includes('OnlyOwnTasks=true') ? 1 : props.specialFilter.includes('OnlyOwnTasks=false') ? 0 : '' },
        { Key: 'FromRole', Value: props.specialFilter.includes('FromRole=true') ? 1 : props.specialFilter.includes('FromRole=false') ? 0 : '' },*/
    ] as any);

    const [personInChargeID, setPersonInChargeID] = useState(null as any);
    const [personInChargeNumber, setPersonInChargeNumber] = useState(null as any);
    const [prevSelectedFilter, setPrevSelectedFilter] = useState(-1);
    const translationMap = {
        q1: 17281,
        q2: 17282,
        q3: 17283,
        q4: 17284,
        qN: 17285,
        h1: 17286,
        h2: 17287,
        hN: 17288,
    };
    /// Called when the Filter is first initialized (a Table Page gets opened)
    /// If there is no filter parameter in the url it will look through the DefaultFilters one can set in the Designer and add them to the url if they exist
    useEffect(() => {
        var storageFilters = SessionStorage.getData(LocalStorage?.getTabData()?.primaryType + '_' + props.filterName);
        if (!props.filterQuery && !storageFilters && props.filters) {
            loadFilter(props.filters);
        }
        if (storageFilters && props.filters) {
            storageFilters
                .replaceAll('(', '')
                .replaceAll(')', '')
                .replaceAll('"', '')
                .replaceAll('%', '')
                .replaceAll(' OR ', ' AND ')
                .split(' AND ')
                .forEach((filter: any) => {
                    const filterData = filter.split(' ');
                    var filterDesign = props.filters.Data.find(d => d.Key === filterData[0].replace('.', '-'));
                    if (filterDesign?.Type === 'bool' || filterDesign?.Type === 'boolnon') {
                        changeFilterValuesHandler({ newValue: filterData[2], designData: filterDesign });
                    }
                });
            props.setUrlParams(props.filterName, storageFilters);
        } else if (props.filterQuery && props.filters) {
            props.filterQuery
                .replaceAll('(', '')
                .replaceAll(')', '')
                .replaceAll('"', '')
                .replaceAll('%', '')
                .replaceAll(' OR ', ' AND ')
                .split(' AND ')
                .forEach((filter: any) => {
                    const filterData = filter.split(' ');
                    var filterDesign = props.filters.Data.find(d => d.Key === filterData[0].replace('.', '-'));
                    if (filterDesign?.Type === 'bool' || filterDesign?.Type === 'boolnon') {
                        changeFilterValuesHandler({ newValue: filterData[2], designData: filterDesign });
                    }
                });
        }
        if (props.filters) {
            props.filters.Data.filter(f => f.ReadOnly && !f.ProfCrit).forEach(f => {
                if (f.Type === 'bool' || f.Type === 'boolnon') {
                    changeFilterValuesHandler({ newValue: f.DefaultValue, designData: f });
                }
            });
        }
        //#region SpecialFilter
        if (props.specialFilter && props.filters) {
            props.specialFilter.split('&').forEach((filter: any) => {
                if (!filter) return;
                const filterData = filter.split('=');
                var filterDesign = props.filters.Data.find(d => d.FilterName === filterData[0]);
                if (filterDesign && filterDesign.Type === 'bool') {
                    setSpecialFilterValue(filterData[0], filterData[1] === 'true' ? 1 : filterData[1] === 'false' ? -1 : 0, filterDesign);
                }
                if (filterDesign && filterDesign.Type === 'boolnon') {
                    setSpecialFilterValue(filterData[0], filterData[1] === 'true' ? 1 : 0, filterDesign);
                } else if (filterDesign) {
                    setSpecialFilterValue(filterData[0], filterData[1], filterDesign);
                }
            });
        }
        //#endregion SpecialFilter

        if (props.filters) {
            loadProfCritFilter(props.filters);
        }
        /// Tells the Table that the data can be loaded (if not used 2 api calls would be made and most of the  the unfiltered result overwrites the filtered since it takes longer)
        props.setDefaultFiltersLoaded(true);
    }, []);

    useEffect(() => {
        if (props.selectedFilter !== undefined && props.selectedFilter !== null && props.selectedFilter !== prevSelectedFilter) {
            setPrevSelectedFilter(props.selectedFilter);
            loadFilter(getFilterByType(), true);
            loadProfCritFilter(getFilterByType());
        }
    }, [props.selectedFilter]);

    function loadFilter(filter, overwrite = false) {
        let query = '';
        filter.Data.filter(f => f.DefaultValue && !f.SpecialFilter && !f.ProfCrit).forEach(d => {
            if (typeof d.DefaultValue === 'string' && d.DefaultValue.toLowerCase().split('.')[0] === 'userdata') {
                d.DefaultValue = LocalStorage?.getData('UserData') ? LocalStorage?.getData('UserData')[d.DefaultValue.split('.')[1]] : d.DefaultValue;
                if (isNaN(d.DefaultValue)) d.DefaultValue = 999;
            }
            if (d.Type === 'bool' || d.Type === 'boolnon') {
                changeFilterValuesHandler({ newValue: d.DefaultValue, designData: d });
            }
            var extraFilter = '';
            if (d.Type === 'date' || d.Type === 'date-local') {
                extraFilter = specialDateFilters(d);
            }
            if (d.Operator === 'IS') query += (query !== '' ? ' AND (' : '(') + d.Key.replaceAll('-', '.') + ' IS ' + d.DefaultValue + ')';
            else query += (query !== '' ? ' AND (' : '(') + d.Key.replaceAll('-', '.') + ' ' + (d.Operator ?? '=') + ' "' + (d.Operator === 'LIKE' ? '%' + d.DefaultValue + '%' : d.DefaultValue) + '")' + (extraFilter ? ' AND ' + extraFilter : '');
        });

        if (query || overwrite) props.setUrlParams(props.filterName, query);
    }

    function loadProfCritFilter(filter) {
        var profCritArray = [] as any;
        filter?.Data?.filter(f => f.DefaultValue && f.ProfCrit).forEach(d => {
            if (typeof d.DefaultValue === 'string' && d.DefaultValue.toLowerCase().split('.')[0] === 'userdata') {
                d.DefaultValue = LocalStorage?.getData('UserData') ? LocalStorage?.getData('UserData')[d.DefaultValue.split('.')[1]] : d.DefaultValue;
                if (isNaN(d.DefaultValue)) d.DefaultValue = 999;
            }

            if (d.Type === 'date' || d.Type === 'date-local') {
                var defaultFilters = convertSpecialDateFilterToProfCritFilters(d);
                profCritArray = profCritArray.concat(defaultFilters);
                defaultFilters.forEach((filter: any) => {
                    changeFilterValuesHandler({ newValue: filter.Values[0], designData: { ...d, Operator: filter.CompareType } });
                });
            } else {
                if (d.Type === 'bool' || d.Type === 'boolnon') {
                    d.DefaultValue = d.DefaultValue === '1' ? 'true' : d.DefaultValue === '0' ? 'false' : '';
                }
                profCritArray.push({
                    Criteria: d.Key,
                    Type: getProfCritType(d.Type),
                    CompareType: convertOperatorToEnum(d.Operator ?? '='),
                    Values: [d.DefaultValue],
                });
                changeFilterValuesHandler({ newValue: d.DefaultValue, designData: d });
            }
        });
        if (props.setProfCritFilter) props.setProfCritFilter(profCritArray);
    }
    function specialDateFilters(d: any) {
        const date = new Date();
        const month = date.getMonth();
        switch (d.DefaultValue) {
            case 'NOW':
                date.setDate(date.getDate() + (+d.DefaultValueOffset || 0));
                d.DefaultValue = date.toISOString().substring(0, 10);
                break;
            case 'q1':
                date.setMonth(0);
                date.setDate(1);
                d.DefaultValue = date.toISOString().substring(0, 10);
                d.Operator = '>=';
                date.setMonth(3);
                date.setDate(0);
                return '(' + d.Key + ' <= "' + date.toISOString().substring(0, 10) + '")';
            case 'q2':
                date.setMonth(3);
                date.setDate(1);
                d.DefaultValue = date.toISOString().substring(0, 10);
                d.Operator = '>=';
                date.setMonth(6);
                date.setDate(0);
                return '(' + d.Key + ' <= "' + date.toISOString().substring(0, 10) + '")';
            case 'q3':
                date.setMonth(6);
                date.setDate(1);
                d.DefaultValue = date.toISOString().substring(0, 10);
                d.Operator = '>=';
                date.setMonth(9);
                date.setDate(0);
                return '(' + d.Key + ' <= "' + date.toISOString().substring(0, 10) + '")';

            case 'q4':
                date.setMonth(9);
                date.setDate(1);
                d.DefaultValue = date.toISOString().substring(0, 10);
                d.Operator = '>=';
                date.setMonth(11);
                date.setDate(31);
                return '(' + d.Key + ' <= "' + date.toISOString().substring(0, 10) + '")';

            case 'qN':
                date.setMonth(month < 3 ? 0 : month < 6 ? 3 : month < 9 ? 6 : 9);
                date.setDate(1);
                d.DefaultValue = date.toISOString().substring(0, 10);
                d.Operator = '>=';
                date.setMonth(month < 3 ? 3 : month < 6 ? 6 : month < 9 ? 9 : 0);
                date.setDate(0);
                return '(' + d.Key + ' <= "' + date.toISOString().substring(0, 10) + '")';

            case 'h1':
                date.setMonth(0);
                date.setDate(1);
                d.DefaultValue = date.toISOString().substring(0, 10);
                d.Operator = '>=';
                date.setMonth(6);
                date.setDate(0);
                return '(' + d.Key + ' <= "' + date.toISOString().substring(0, 10) + '")';

            case 'h2':
                date.setMonth(6);
                date.setDate(1);
                d.DefaultValue = date.toISOString().substring(0, 10);
                d.Operator = '>=';
                date.setMonth(11);
                date.setDate(31);
                return '(' + d.Key + ' <= "' + date.toISOString().substring(0, 10) + '")';

            case 'hN':
                date.setMonth(month < 6 ? 0 : 6);
                date.setDate(1);
                d.DefaultValue = date.toISOString().substring(0, 10);
                d.Operator = '>=';
                date.setMonth(0);
                date.setDate(month < 6 ? 6 : 0);
                return '(' + d.Key + ' <= "' + date.toISOString().substring(0, 10) + '")';
        }
        return '';
    }
    function convertSpecialDateFilterToProfCritFilters(d: any) {
        const date = new Date();
        const month = date.getMonth();
        var startMonth = 0;
        switch (d.DefaultValue) {
            case 'NOW':
                date.setDate(date.getDate() + (Number(d.DefaultValueOffset) || 0));
                return [
                    {
                        CompareType: convertOperatorToEnum(d.Operator),
                        Criteria: d.Key,
                        Type: 'date',
                        Values: [formatDate(date)],
                    },
                ];

            case 'q1':
                return makeDateRangeFilters(d.Key, 0, 2);
            case 'q2':
                return makeDateRangeFilters(d.Key, 3, 5);
            case 'q3':
                return makeDateRangeFilters(d.Key, 6, 8);
            case 'q4':
                return makeDateRangeFilters(d.Key, 9, 11);

            case 'qN':
                startMonth = month < 3 ? 0 : month < 6 ? 3 : month < 9 ? 6 : 9;
                return makeDateRangeFilters(d.Key, startMonth, startMonth + 2);

            case 'h1':
                return makeDateRangeFilters(d.Key, 0, 5);
            case 'h2':
                return makeDateRangeFilters(d.Key, 6, 11);

            case 'hN':
                startMonth = month < 6 ? 0 : 6;
                return makeDateRangeFilters(d.Key, startMonth, startMonth + 5);

            default:
                return [];
        }
    }

    function makeDateRangeFilters(criteria: string, startMonth: number, endMonth: number) {
        const start = new Date();
        start.setMonth(startMonth, 1);

        const end = new Date();
        end.setMonth(endMonth + 1, 0);

        return [
            {
                CompareType: 'GreaterEqual',
                Criteria: criteria,
                Type: 'date',
                Values: [formatDate(start)],
            },
            {
                CompareType: 'LowerEqual',
                Criteria: criteria,
                Type: 'date',
                Values: [formatDate(end)],
            },
        ];
    }

    function formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function changeFilterValuesHandler(valueObject: any) {
        if (valueObject.designData.ProfCrit) {
            changeProfCritFilterValuesHandler(valueObject);
            return;
        }
        setFilterValues(prev => {
            return {
                ...prev,
                [(valueObject.designData as any).Label]: { value: valueObject.newValueNum ?? (typeof valueObject.newValue === 'object' && typeof valueObject.newValue.getMonth !== 'function') ? valueObject.newValue.value : valueObject.newValue, designData: valueObject.designData },
            };
        });
    }

    function changeProfCritFilterValuesHandler(valueObject: any) {
        setProfCritFilterValues(prev => {
            const existsIndex = prev.findIndex(item => item.Key === valueObject.designData.Key && item.CompareType === convertOperatorToEnum(valueObject.designData.Operator ?? '='));
            if (valueObject.designData.Type === 'bool' || valueObject.designData.Type === 'boolnon') {
                valueObject.newValue = valueObject.newValue === 1 || valueObject.newValue === 'true' ? 'true' : valueObject.newValue === 0 || valueObject.newValue === 'false' ? 'false' : '';
            }
            const shouldRemove = valueObject.newValue === null || valueObject.newValue === undefined || valueObject.newValue === '' || (Array.isArray(valueObject.newValue) && valueObject.newValue.length === 0);

            if (shouldRemove) {
                if (existsIndex !== -1) {
                    const updated = [...prev];
                    updated.splice(existsIndex, 1);
                    return updated;
                }
                return prev;
            }

            const newEntry = {
                Key: valueObject.designData.Key,
                Criteria: valueObject.designData.Criteria,
                Type: getProfCritType(valueObject.designData.Type),
                CompareType: convertOperatorToEnum(valueObject.designData.Operator ?? '='),
                Values: valueObject.designData.Type === 'dropdownMulti' ? valueObject.newValue : [valueObject.newValue],
            };

            if (existsIndex !== -1) {
                const updated = [...prev];
                updated[existsIndex] = newEntry;
                return updated;
            } else {
                return [...prev, newEntry];
            }
        });
    }

    function getProfCritType(type) {
        switch (type) {
            case 'bool':
            case 'boolnon':
                return 'boolean';
            case 'date':
                return 'date';
            case 'date-local':
                return 'date';
            case 'number':
                return 'number';
            default:
                return 'string';
        }
    }

    function convertOperatorToEnum(op) {
        const operatorMap = {
            '=': 'Equals',
            '!=': 'NotEquals',
            '<': 'Lower',
            '<=': 'LowerEqual',
            '>': 'Greater',
            '>=': 'GreaterEqual',
            is: 'IsNull',
            'is not': 'IsNotNull',
            in: 'InList',
            'not in': 'NotInList',
            like: 'Like',
        };

        const normalized = op.trim().toLowerCase();
        const match = operatorMap[normalized];
        if (!match) {
            return op;
        }

        return match;
    }

    /// Called when the "Filter" button gets pressed.
    /// Adds the filter that was given in the filter input fields to the url
    /// If a specific filter already exists in the url it gets ignored
    function filterTable() {
        let query: string = props.filterQuery ?? '';
        if (filterValues) {
            const queryRep = query.replaceAll('(', '').replaceAll(')', '').replaceAll('%', '');
            Object.entries(filterValues).forEach((val: any) => {
                const key = val[1].designData.Key.replaceAll('-', '.'); //filterHelper(val[1].designData.Key.replaceAll('-', '.'));
                if (val[1].value === '' && (val[1].designData.Type === 'bool' || val[1].designData.Type === 'boolnon') && queryRep.includes(key + ' =')) {
                    const inx = query.indexOf(' AND (' + key + ' = "');
                    query = query.substring(0, inx) + query.substring(inx + val[1].designData.Key.length + 13);
                    return;
                } else if (val[1].value === '' || val[1].value === undefined) return;
                if (queryRep.includes(key + ' ' + (val[1].designData.Operator ?? '=') + ' "' + val[1].value + '"')) return;
                if ((val[1].designData.Type === 'bool' || val[1].designData.Type === 'boolnon') && queryRep.includes(key + ' =')) {
                    const inx = query.indexOf(key + ' = "') + val[1].designData.Key.length + 4;
                    query = query.substring(0, inx) + val[1].value + query.substring(inx + 1);
                } else if (val[1].designData.Type === 'date' && (!val[1].designData.Operator || val[1].designData.Operator !== '=') && queryRep.includes(key + ' ' + val[1].designData.Operator)) {
                    const inx = query.indexOf(key + ' ' + val[1].designData.Operator + ' "') + val[1].designData.Key.length + 3 + val[1].designData.Operator.length;
                    query = query.substring(0, inx) + val[1].value + query.substring(inx + 10);
                } else if (queryRep.includes(key + ' ' + (val[1].designData.Operator ?? '='))) {
                    const inx = query.indexOf(key + ' ' + (val[1].designData.Operator ?? '='));
                    query = query.substring(0, inx) + key + ' ' + (val[1].designData.Operator ?? '=') + ' "' + (val[1].designData.Operator === 'LIKE' ? '%' + val[1].value + '%' : val[1].value) + '" OR ' + query.substring(inx);
                } else {
                    query += (query !== '' ? ' AND (' : '(') + key + ' ' + (val[1].designData.Operator ?? '=') + ' "' + (val[1].designData.Operator === 'LIKE' ? '%' + val[1].value + '%' : val[1].value) + '")';
                }
                if (val[1].designData.Type !== 'bool' && val[1].designData.Type !== 'boolnon' && (val[1].designData.Type !== 'date' || (val[1].designData.Type === 'date' && val[1].designData.Operator === '='))) delete filterValues[val[1].designData.Label];
            });
            setFilterValues({ ...filterValues });
            props.setUrlParams(props.filterName, query);
        }
        let f = { value: false };
        specialFilter?.forEach(f => {
            props.setSpecialFilter(f.Key + '=' + (f.Value === false ? false : f.Value || ''));
        });
        if (props.setProfCritFilter) props.setProfCritFilter(profCritFilterValues);
    }

    function getSpecialFilterValue(key) {
        return specialFilter.find(f => f.Key === key)?.Value;
    }
    function setSpecialFilterValue(key, value, designData = null as any) {
        setSpecialFilter(prev => {
            var specialCopy = JSON.parse(JSON.stringify(prev));
            var inx = specialCopy.findIndex(f => f.Key === key);
            if (inx !== -1) {
                specialCopy.splice(inx, 1, { Key: key, Value: designData?.Type === 'bool' || designData?.Type === 'boolnon' ? (value === 1 ? true : false) : value });
            } else {
                specialCopy.push({ Key: key, Value: designData?.Type === 'bool' || designData?.Type === 'boolnon' ? (value === 1 ? true : false) : value });
            }
            return specialCopy;
        });
    }

    /// Called when the "x" button in the "Selected Filter" section gets clicked
    /// Deletes the specified filter from the url.
    function removeFilter(filterData: any, designData: any, readOnly: boolean) {
        if (!readOnly) {
            const filterValue = filterData.slice(2).join(' ');
            setFilterValues(prev => {
                return {
                    ...prev,
                    [designData.Label]: { value: '', designData: designData },
                };
            });

            let query = '';
            if (filterData[1] === 'IS') query = props.filterQuery.replace(filterData[0].replaceAll('-', '.') + ' ' + (filterData[1] ?? '=') + ' ' + filterValue, '');
            else query = props.filterQuery.replace(filterData[0].replaceAll('-', '.') + ' ' + (filterData[1] ?? '=') + ' "' + (filterData[1] === 'LIKE' ? '%' + filterValue + '%' : filterValue) + '"', '');
            query = query.replace(' OR )', ')').replace('( OR ', '(').replace('OR  OR', 'OR').replace(' AND ()', '').replace('() AND ', '').replace('()', '');
            props.setUrlParams(props.filterName, query);
        }
    }

    function removeAllFilters() {
        var filterVals = {};
        if (filterValues) {
            Object.entries(filterValues)
                .filter((f: any) => f[1].designData.ReadOnly)
                .forEach(f => {
                    filterVals = { ...filterVals, [f[0]]: f[1] };
                });
            setFilterValues(filterVals);
        }
        var query = '';
        props.filters.Data.filter(f => f.ReadOnly).forEach(f => {
            if (query) query += ' AND ';
            query += '(' + f.Key + ' ' + (f.Operator ?? '=') + ' "' + (f.Operator === 'LIKE' ? '%' + f.DefaultValue + '%' : f.DefaultValue) + '")';
        });

        props.setUrlParams(props.filterName, query);
    }

    useEffect(() => {
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetDropdownValues + 'PersonInChargeID').then(data => {
            setPersonInChargeID(data.Data);
        });
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetDropdownValues + 'PersonInChargeNumber').then(data => {
            setPersonInChargeNumber(data.Data);
        });
    }, []);

    function getFilterValue(label) {
        if (filterValues) {
            var val = filterValues[label]?.value;
            if ((val === '1' || val === 1) && (filterValues[label]?.designData.Type === 'bool' || filterValues[label]?.designData.Type === 'boolnon')) {
                return true;
            } else if ((val === 0 || val === '0') && (filterValues[label]?.designData.Type === 'bool' || filterValues[label]?.designData.Type === 'boolnon')) {
                return false;
            }
            return val ?? '';
        }
        return '';
    }
    function getProfCritFilterValue(key, operator) {
        var x = profCritFilterValues.find(item => item.Criteria === key && item.CompareType === convertOperatorToEnum(operator ?? '='));
        if (x?.CompareType === 'InList' || x?.CompareType === 'NotInList') {
            return x?.Values;
        }
        return x?.Values[0] ?? '';
    }

    function getFilterByType() {
        return props.selectedFilter >= 0 && props.preMadeFilters?.[props.selectedFilter] ? props.preMadeFilters?.[props.selectedFilter] : props.filters;
    }

    function getTranslationByValue(value) {
        const key = translationMap[value];
        return key ? window.Dictionary.getTranslation(key) : null;
    }
    return (
        <>
            {props.filterActive && (
                <div className="mfx-filter">
                    {/*<h3>{window.Dictionary.getTranslation(835)}</h3>*/}
                    {props.filterQuery && (
                        <div className="mfx-grid-container selected-filter">
                            <div className="mfx-col-12">
                                <h4>{window.Dictionary.getTranslation(14231)}: </h4>
                                <ul>
                                    {props.filterQuery
                                        .replaceAll('(', '')
                                        .replaceAll(')', '')
                                        .replaceAll('"', '')
                                        .replaceAll('%', '')
                                        .replaceAll(' OR ', ' AND ')
                                        .split(' AND ')
                                        .map((filter: any) => {
                                            const filterData = filter.split(' ');
                                            var filterDesign = getFilterByType()?.Data?.find(d => d.Key === filterData[0].replaceAll('.', '-') && (d.Operator ?? '=') === filterData[1]) ?? getFilterByType()?.Data?.find(d => d.Key === filterData[0].replaceAll('.', '-'));
                                            const filterValue =
                                                filterData[0].replaceAll('.', '-') === 'PersonInChargeID'
                                                    ? personInChargeID?.find(p => p.Value === filterData.slice(2).join(' '))?.Name
                                                    : filterData[0].replaceAll('.', '-') === 'PersonInChargeNumber'
                                                    ? personInChargeNumber?.find(p => p.Value === filterData.slice(2).join(' '))?.Name
                                                    : filterData.slice(2).join(' ');
                                            console.log(filterDesign, filterValue);
                                            if (filterDesign && filterValue)
                                                return (
                                                    <li>
                                                        {window.Dictionary.getTranslation(filterDesign.Label)} {filterData[1] === 'LIKE' ? '~' : filterData[1]}{' '}
                                                        {filterDesign.Type === 'bool' ? (filterValue === '1' ? window.Dictionary.getTranslation(1651) : window.Dictionary.getTranslation(1652)) : filterValue}
                                                        {!filterDesign.ReadOnly && (
                                                            <button
                                                                disabled={filterDesign.ReadOnly}
                                                                type="button"
                                                                className="no-styling clear-filters-button"
                                                                onClick={e => {
                                                                    removeFilter(filterData, filterDesign, filterDesign.ReadOnly);
                                                                }}>
                                                                <i className="fas fa-close"></i>
                                                            </button>
                                                        )}
                                                    </li>
                                                );
                                            else return <></>;
                                        })}
                                    {getFilterByType()
                                        .Data.filter(f => (f.Type === 'date' || f.Type === 'date-local') && getTranslationByValue(f.DefaultValue))
                                        .map(f => {
                                            return (
                                                <li>
                                                    {window.Dictionary.getTranslation(f.Label)}: {window.Dictionary.getTranslation(getTranslationByValue(f.DefaultValue))}
                                                </li>
                                            );
                                        })}
                                    {props.filterQuery && (
                                        <button onClick={removeAllFilters}>
                                            <i className="icon-delete"></i>
                                        </button>
                                    )}
                                </ul>
                            </div>
                        </div>
                    )}
                    <div className="mfx-grid-container">
                        {getFilterByType()?.Data?.map((data: any) => {
                            var customValue = data.SpecialFilter ? getSpecialFilterValue(data.FilterName ?? data.Key) : data.ProfCrit ? getProfCritFilterValue(data.Key, data.Operator) : filterValues && getFilterValue(data.Label);
                            switch (data.Type) {
                                case 'bool':
                                    return (
                                        <div className="mfx-filter-col checkbox">
                                            <YesOrNoElement
                                                value={customValue === true || customValue === 'true' ? 1 : customValue === false || customValue === 'false' ? 0 : -1}
                                                designData={data}
                                                onChangeHandler={e => (data.SpecialFilter ? setSpecialFilterValue(data.FilterName ?? data.Key, e.newValue, data) : changeFilterValuesHandler(e))}
                                            />
                                        </div>
                                    );
                                case 'boolnon':
                                    return (
                                        <div className="mfx-filter-col checkbox">
                                            <YesOrNoElement
                                                noNeutral={true}
                                                value={customValue === true || customValue === 'true' ? 1 : 0}
                                                designData={data}
                                                onChangeHandler={e => (data.SpecialFilter ? setSpecialFilterValue(data.FilterName ?? data.Key, e.newValue, data) : changeFilterValuesHandler(e))}
                                            />
                                        </div>
                                    );
                                case 'dropdown':
                                case 'dropdownMulti':
                                    return (
                                        <div className="mfx-filter-col dropdown">
                                            <Dropdown
                                                customId={getSpecialFilterValue('CustomerNumber')}
                                                designData={data}
                                                isFilter={true}
                                                isMulti={data.Type === 'dropdownMulti'}
                                                customerData={customValue}
                                                onChangeHandler={e => (data.SpecialFilter ? setSpecialFilterValue(data.FilterName ?? data.Key, e.newValue, data) : changeFilterValuesHandler(e))}
                                                onEnterPressed={filterTable}
                                            />
                                        </div>
                                    );
                                default:
                                    return (
                                        <div className="mfx-filter-col input">
                                            <InputElement
                                                isFilter={true}
                                                designData={{ ...data }}
                                                customerData={customValue}
                                                onChangeHandler={e => (data.SpecialFilter ? setSpecialFilterValue(data.FilterName ?? data.Key, e.newValue, data) : changeFilterValuesHandler(e))}
                                                onEnterPressed={filterTable}
                                                ignoreDefaultValue={true}
                                            />
                                        </div>
                                    );
                            }
                        })}
                    </div>
                    <div className="mfx-grid-container">
                        <button className="mfx-button right" id="filter-start" onClick={() => filterTable()}>
                            <span className="icon-filter"></span>
                            {window.Dictionary.getTranslation(14938)}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}
